export default __webpack_public_path__ + "static/media/exe.7b2fe963.svg";